import { NavLink } from "react-router-dom";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
} from "~/components/ui";
import { routes } from "~/lib/constants";
import { findRecordWithFullAccess } from "~/lib/utils";
import { useSelector } from "~/redux/store";

const CreateAction = () => {
  const permissions = useSelector(
    (state) => state.persistedReducer.auth.permissions,
  );

  const accessibleMenuItems = MenuItems.filter((menu) =>
    findRecordWithFullAccess(permissions, menu.id),
  );

  if (accessibleMenuItems.length === 0) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="default"
          size="default"
          className="flex h-9 items-center gap-2"
        >
          <Icon name="Plus" className="h-4 w-4 text-secondary-500" />
          <span>Create</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {accessibleMenuItems
          ?.filter((m) => findRecordWithFullAccess(permissions, m?.id))
          ?.map((item, index) => (
            <DropdownMenuItem key={index} className="group cursor-pointer">
              <NavLink to={item?.link} className="">
                {item?.name}
              </NavLink>
            </DropdownMenuItem>
          ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

const MenuItems = [
  {
    id: "create_incidents",
    name: "Incident",
    link: routes.newIncident(),
  },
  {
    id: "create_observations",
    name: "Observation",
    link: routes.newObservation(),
  },
  {
    id: "create_eligibility_permits",
    name: "Eligibility Permit",
    link: routes.newEligibilityPermit(),
  },
  {
    id: "create_competence_permits",
    name: "Competence Permit",
    link: routes.newCompetencePermit(),
  },
  {
    id: "create_company_wide_permits",
    name: "Company-Wide Permit",
    link: routes.newCompanyWidePermit(),
  },
  {
    id: "create_site_specific_permits",
    name: "Site-Specific Permit",
    link: routes.newSiteSpecificPermit(),
  },
  {
    id: "create_inspections",
    name: "Inspection",
    link: routes.newInspection(),
  },
  {
    id: "create_audits",
    name: "Audit",
    link: routes.newAudit(),
  },
];
export default CreateAction;
